import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import './assets/css/icon.css'
import filters from "./common/filters.js"
import * as uni from './utils/uni.webview.1.5.2.js'  
document.addEventListener("UniAppJSBridgeReady", function() {  
  app.config.globalProperties.$uni = uni  
});

import Vant from 'vant'
import 'vant/lib/index.css'


import JSEncrypt from 'jsencrypt';
let Base64 = require('js-base64').Base64;

// v3-drag-zoom 组件
import V3DragZoom from "v3-drag-zoom";
// v3-drag-zoom 全局样式（必须导入，否则无法正常使用）
import "v3-drag-zoom/dist/style.css";


import VueDragResizeRotate from "@gausszhou/vue3-drag-resize-rotate";
import "@gausszhou/vue3-drag-resize-rotate/lib/bundle.esm.css";

axios.defaults.withCredentials = true;

const app = createApp(App)

// 注册全局过滤器
Object.keys(filters).forEach(key => {
  app.config.globalProperties[`$${key}`] = filters[key]
})

// 全局属性配置
app.config.globalProperties.$jsEncrypt = JSEncrypt
app.config.globalProperties.$axios = axios
app.config.globalProperties.$filters = filters

app
  .use(store)
  .use(router)
  .use(ElementPlus)
  .use(Vant)
  .use(Base64)
  .use(V3DragZoom)
  .use(VueDragResizeRotate)
  .mount('#app')